import { createApp } from 'vue';
import MapDrive from '@/pages/MapDriveReport.vue';

/**
 * 安全運転指導ページ用のスクリプト
 */
if (is_route('safety_guidance.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        safety_guidance_event_set();
        safety_guidance_video_control();
    });
}

window.safety_guidance_event_set = function() {
    let formId = '#safety_guidance-';

    // 検索用のインプットフォームの変更時にformの発火を防ぐ
    $(document).on('change',formId+'search-form input', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });


    // 検索用のセレクトフォームの変更時にformの発火を防ぐ
    $(document).on('change',formId+'search-form select', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //検索開始日時
    $(document).on('change', formId+'search-form-start_time', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let last_day = null;
        let selected_date = $(this).val();
        let set_end = $(formId+'search-form-end_time').val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            let chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31,selected_date.getHours(),selected_date.getMinutes());
            let chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate(),selected_date.getHours(),selected_date.getMinutes());
            set_end = new Date(set_end);
            let yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate(),set_end.getHours(),set_end.getMinutes());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0" + ( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + yyyymmdd.getDate() ).slice(-2);
                $(formId+'search-form-end_time').val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                 last_day = chk_date.getFullYear()+'/'+
                        ( "0" + ( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + chk_date.getDate() ).slice(-2) ;
                $(formId+'search-form-end_time').val(last_day);
            }
        }

    });

    //検索終了日時
    $(document).on('change', formId+'search-form-end_time', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let last_day = null;
        let selected_date = $(this).val();
        let set_start = $(formId+'search-form-start_time').val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            let yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31,set_start.getHours(),set_start.getMinutes());
            let yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate(),set_start.getHours(),set_start.getMinutes());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() - 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0" + ( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + yyyymmdd.getDate() ).slice(-2);
                $(formId+'search-form-start_time').val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                yyyymmdd_2 = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() - 31);
                last_day = selected_date.getFullYear()+'/'+
                        ( "0" + ( selected_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + selected_date.getDate() ).slice(-2);
                $(formId+'search-form-start_time').val(last_day);
            }
        }
    });

    // 会社変更時
    $(document).on('change', formId + 'search-form-company_id', function () {
        _select.set_select(this, formId + 'search-form-section_id', {'company_id': $(this).val()});
    });

    // 全て選択用のチェックボックス
    $(document).on('change', '#all-select-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).prop('checked')) {
            //個別のイベント種別チェックボックスからチェックを外して、非選択状態の状態にする
            $('.event_type-check').prop('checked', false);
        }else {
            // 自分自身のチェックは外させない(全て選択のチェックが外れるのは個別チェックボックスの押下時のみ)
            $(this).prop('checked', true);
        }
    });

    // イベント種別の個別チェックボックス
    $(document).on('change', '.event_type-check', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // 全て選択チェックボックスが選択状態だったら、非選択状態にする
        if ($('#all-select-btn').prop('checked')) {
            $('#all-select-btn').prop('checked', false);
        }
        if($('.event_type-check:checked').length <= 0) {
            //全てのチェックボックスのチェックが外れていたら全て選択を選択状態にする
            $('#all-select-btn').prop('checked', true);
        }
    });

    //検索ボタンクリックでformを動作させる
    $(document).on('click',formId+'search-btn', function(event) {
        //グループ会社が選択されていない場合検索は行わない。
        if( $('input[name="holding_id"]').length > 0) {
            let selector = formId+'search-form';
            // チェックボックスの状態をクエリパラメータに反映させる
            let action = $(selector).prop('action');
            $('.event_type-check').each(function() {
                if (!$(this).prop('checked')) {
                    _request.remove_parameters(action, [$(this).prop('name')]);
                }
            });

            //更新
            let datas = $('#safety_guidance-search-form').serializeArray();
            let excutionData = [];
            excutionData.push('holding_id', 'company_id', 'section_id');
            console.log(excutionData);
            action = $(selector).attr('action').replace('/list', '');
            action = _request.create_affiliation_url(action, true, datas, excutionData);
            location.href = action;
            return false;
        }
    });

    // 動画保護
    $(document).on('click','.change_lock_btn', function() {
        let action = extend_url_query($(this).data('action'));
        let btn = $(this);
        let drive_operation_video_id = $(this).data('drive_operation_video_id')
        let modal_btn = $(this).closest('tr').find('input.safety_guidance_modal_btn');
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'id',value:$(this).data('id')},
            {name:'drive_operation_video_id',value:drive_operation_video_id},
            {name:'is_locked',value:$(this).data('is_locked')},
        ];
        _ajax.post(action,datas, function (response) {
            btn.children('img').attr('src', response.image);
            btn.attr('data-id', response.id);
            btn.data('id', response.id);
            btn.attr('data-is_locked', response.is_locked);
            btn.data('is_locked', response.is_locked);

            //モーダル用のidにも設定しておく
            modal_btn.attr('data-id', response.id);
            modal_btn.data('id', response.id);

            // 完了メッセージをセットする
            toastr.success(response.message);
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /* ファイルダウンロード関連 */
    //全選択・全解除
    $(document).on('change','#all_check',function () {
        if ($(this).prop('checked')) {
            // リスト内全ての選択用チェックボックスにチェックを付ける
            $('.check_video_data').prop('checked', true);
            $('#safety_guidance-video_download').removeAttr('disabled');
            $('#safety_guidance-multiple_video_play').removeAttr('disabled');
        }else {
            // リスト内全ての選択用チェックボックスにチェックを外す
            $('.check_video_data').prop('checked', false);
            $('#safety_guidance-video_download').attr('disabled', 'disabled');
            $('#safety_guidance-multiple_video_play').attr('disabled', 'disabled');
        }
    });

    // 各データごとの個別チェックボックス
    $(document).on('change', '.check_video_data', function(e) {
        if($('.check_video_data:checked').length <= 0) {
            $('#safety_guidance-video_download').attr('disabled', 'disabled');
            $('#safety_guidance-multiple_video_play').attr('disabled', 'disabled');
        } else {
            $('#safety_guidance-video_download').removeAttr('disabled');
            $('#safety_guidance-multiple_video_play').removeAttr('disabled');
        }
    });

    // 動画ダウンロード
    $(document).on('click', formId+'video_download', function () {
        if($('input[name="holding_id"]').length <= 0) {
            toastr.warning('グループ会社が選択されていません。');
        } else if($('input[name^="check_video_data"]:checked').length <= 0) {
            toastr.warning('一覧からダウンロードしたい動画にチェックをしてください。');
        } else {
            // アクションの取得
            let action = extend_url_query($(this).data('action'));
            // 一覧にあるデータのチェックされたものを配列化する
            let ids = $('input[name^="check_video_data"]:checked').map(function() {
                return $(this).val();
            }).get();
            let datas = [
                {name:'_token',value:$('input[name="_token"]').val()},
                {name:'holding_id',value:$('input[name="holding_id"]').val()},
                {name:'ids',value:JSON.stringify(ids)},
            ];
            // 送信
            post(action, datas);
        }
    });

    //個別のダウンロードボタン
    $(document).on('click', '.download_btn', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 一覧にあるデータのチェックされたものを配列化する
        let id = $(this).data('id');
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'holding_id',value:$('input[name="holding_id"]').val()},
            {name:'id',value:id},
        ];
        // 送信
        post(action, datas);
    });

    // 動画表示用モーダルを表示する
    $(document).on('click', '[data-guidance-modal]', function () {
        _modal.create(this, 'guidance-modal', ['id','drive_operation_video_id','holding_id','company_id'], false, function(){
            setTimeout(function () {
                const zMapMain = $('#guidance-modal').find('.safety_guidance-map');
                const app = createApp(MapDrive, {
                    lat: String(zMapMain.data('zip_lat')),
                    lon: String(zMapMain.data('zip_lon')),
                    vehicleData: zMapMain.data('safety_guidance_map_data'),
                });
                app.mount(zMapMain.get(0));
            }, 1000);
        });
        return false;
    });

    //連続再生用のモーダルを表示する
    $(document).on('click', '[data-multiple_video-modal]', function () {
        if($('input[name="holding_id"]').length <= 0) {
            toastr.warning('グループ会社が選択されていません。');
        } else if($('input[name^="check_video_data"]:checked').length <= 0) {
            toastr.warning('一覧から再生したい動画にチェックをしてください。');
        } else {
            let select_ids = $('input[name^="check_video_data"]:checked').map(function() {
                return $(this).val();
            }).get();
            $(this).data('select_ids', JSON.stringify(select_ids));

            _modal.create(this, 'multiple_video-modal', ['select_ids','holding_id','company_id','start_time','end_time']);
            return false;
        }
    });

    //データ保存処理を実行
    $(document).on('click','#modal-safety_guidance-submit', function(event) {
        _ajax.submit('#safety_guidance-edit-form', function(results){
            $('#modal-id').val(results.id);
            toastr.success(results.message);
            $('video[id^="modal-safety_guidance-player-"]').each(function() {
                let vdo = $(this)[0];
                vdo.pause();
            });
            $('.modal-content').empty();
            $('.modal-content').hide();
            let callback = null;
            let isExtendPageQuery =  true;
            let selector = formId+'search-form';
            let replaceSelector = '#contents';
            // チェックボックスの状態をクエリパラメータに反映させる
            let action = $(selector).prop('action');
            $('.event_type-check').each(function() {
                if (!$(this).prop('checked')) {
                    _request.remove_parameters(action, [$(this).prop('name')]);
                }
            });
            $(selector).prop('action', action);
            //リスト更新
            load_contents(callback, isExtendPageQuery, selector, replaceSelector, false);
        }, function(xhr, status, errorThrown){
            _error.set('#guidance-modal', xhr, status, errorThrown, false);
        });
    });
}

window.safety_guidance_video_control = function() {
    // 動画表示時
    // リア動画URL保持
    let uri_rear = '';
    let curr_index = 0;
    let select_videos;
    let frontVideo;
    let rearVideo;
    let nowTime;
    let isUserSeeking = false;

    $(document).on('click', '[id^="modal-safety_guidance-row"]', function () {
        $('#modal-safety_guidance-play_stop').trigger('click');
        $('#modal-safety_guidance-time-slider').val(0);

        $('#drive_report_events tbody tr').removeClass('table-primary');
        $(this).addClass('table-primary');

        let videos = $(this).data('videos');
        if (videos) {
            if(videos[0]['camera_type'] == 'compiled-import') {
                $('#modal-safety_guidance-player-front source').attr('src', videos[0].uri);
                $('#modal-safety_guidance-player-rear source').attr('src', '');
                $('#video_box').addClass('multiple_video_box');

                var nc = $('input[name="cameras"]:checked').val();
                if(nc !='999') {
                    $('#modal-safety_guidance-player-front').addClass('camera'+nc);
                }
                $('#modal-safety_guidance-player-front').removeClass('d-none');
                $('#modal-safety_guidance-player-rear').addClass('d-none');

                $('#modal-safety_guidance-3c').parent().removeClass('d-none');
                $('#modal-safety_guidance-all').parent().removeClass('d-none');

                let front = $('video[id="modal-safety_guidance-player-front"]')[0];
                let rear = $('video[id="modal-safety_guidance-player-rear"]')[0];

                front.currentTime = 0;
                rear.currentTime = 0;

                front.onloadedmetadata = function() {
                    $('#modal-safety_guidance-time-slider').val(0);
                };
                front.load();
                rear.load();

                $('#modal-safety_guidance-play_stop').trigger('click');

            } else {
                $('#video_box').removeClass('multiple_video_box');

                // カメラ数の切り替え
                var nc = $('input[name="cameras"]:checked').val();
                // alert("Selected value: " + nc);
                if(nc != 999) {
                    $('#modal-safety_guidance-player-front').removeClass('camera'+nc);
                }

                if(nc != 2) {
                    $('#modal-safety_guidance-1c').parent().addClass('active');
                    $('#modal-safety_guidance-player-front').removeClass('d-none');
                    $('#modal-safety_guidance-player-rear').addClass('d-none');
                } else {
                    $('#modal-safety_guidance-player-front').addClass('d-none');
                    $('#modal-safety_guidance-player-rear').removeClass('d-none');
                }

                $('#modal-safety_guidance-3c').parent().removeClass('active').addClass('d-none');
                $('#modal-safety_guidance-all').parent().removeClass('active').addClass('d-none');

                // 画像が必ずペア（フロント側とリア側）
                $('video[id^="modal-safety_guidance-player-"]').each(function() {
                    // 動画が必ず２つあるのため、１つずつセットする
                    let id = $(this).attr('id');
                    let cameraType = id.replace('modal-safety_guidance-player-', '');

                    let video = videos.find(video => video.camera_type === cameraType);
                    if (video) {

                        if (cameraType == 'rear') {
                            uri_rear = video.uri;

                            // 1カメラの場合、リア側セットしない
                            if (nc == 1) {
                                return false;
                            }
                        }

                        $(this).find('source').attr('src', video.uri);

                        let vdo = $(this)[0];
                        vdo.load();
                    }
                });

                let front = $('video[id="modal-safety_guidance-player-front"]')[0];
                let rear = $('video[id="modal-safety_guidance-player-rear"]')[0];

                front.currentTime = 0;
                rear.currentTime = 0;

                // ２つの動画の長さが同じのが前提
                front.onloadedmetadata = function() {
                    $('#modal-safety_guidance-time-slider').val(0);
                };
                front.load();
                rear.load();

                $('#modal-safety_guidance-play_stop').trigger('click');
            }
            curr_index = $(this).data('number');

            $('#modal-safety_guidance-2c').parent().removeClass('active').removeClass('focus');
            $('#modal-safety_guidance-3c').parent().removeClass('active').removeClass('focus');
            $('#modal-safety_guidance-all').parent().removeClass('active').removeClass('focus');
            $('#modal-safety_guidance-1c').parent().addClass('active');
        }
    });

    // カメラの切り替え
    $(document).on('change', 'input[name="cameras"]', function () {

        let front = $('#modal-safety_guidance-player-front');
        // 3カメ以上場合
        if($('.multiple_video_box').length) {
            var nc = $(this).val();
            front.removeClass('camera1');
            front.removeClass('camera2');
            front.removeClass('camera3');
            if(nc != 999) {
                front.addClass('camera'+nc);
            }
            let play = play_stop_icon.hasClass('fa-play');
            if (!play) {
                play_stop_icon.removeClass('fa-stop').addClass('fa-play');
            }
            front[0].pause();
        }else{
            let play_stop_icon = $('#modal-safety_guidance-play_stop').find('i');
            let play = play_stop_icon.hasClass('fa-play');
            if (!play) {
                play_stop_icon.removeClass('fa-stop').addClass('fa-play');
            }
            if ($(this).is(':checked')) {
                var nc = $(this).val();

                let rear = $('#modal-safety_guidance-player-rear');
                // 2カメラ
                if (nc == 2) {
                    front.addClass('d-none');
                    rear.removeClass('d-none');

                    if (!rear.find('source').attr('src')) {
                        rear.find('source').attr('src', uri_rear);
                        rear[0].load();
                    }
                    // カメラ２をカメラ１の状態で設定
                    rear[0].volume = front[0].volume;
                    rear[0].currentTime = front[0].currentTime;
                    rear[0].pause();

                    // カメラ1を停止
                    front[0].pause();
                    // front.find('source').attr('src', null);
                }

                // 1カメラ
                if (nc == 1) {
                    front.removeClass('d-none');
                    rear.addClass('d-none');

                    // カメラ１をカメラ２の状態で設定
                    front[0].volume = rear[0].volume;
                    front[0].currentTime = rear[0].currentTime;

                    // カメラ２を停止
                    rear[0].pause();
                    // rear.find('source').attr('src', null);
                }
                // 再生速度を設定
                changeSpeed();
            }
        }
    });

    // イベント動画を閉じる
    $(document).on('click', '#guidance-modal .close', function () {
        closeModal();
    });

    // イベント動画を閉じる
    $(document).on('click', '#multiple_video-modal .close', function () {
        closeModal();
    });

    // イベント動画を閉じる
    $(document).on('click', '#back_btn', function () {
        closeModal();
    });

    // 再生・停止切り替え
    $(document).on('click', '#modal-safety_guidance-play_stop', function () {
        let icon = $(this).find('i');
        let play = icon.hasClass('fa-play');

        let src = '';
        let nc = $('input[name="cameras"]:checked').val();
        $('video[id^="modal-safety_guidance-player-"]').each(function() {
            if (!src) {
                src = $(this).find('source').attr('src');
            }
        });
        if (!src) {
            $('#modal-safety_guidance-row-0').trigger('click');
        }

        let player;
        if($('.multiple_video_box').length) {
            player = $('#modal-safety_guidance-player-front') ;
        } else {
            player = nc == 1 ? $('#modal-safety_guidance-player-front') : $('#modal-safety_guidance-player-rear');
        }

        let vdo = $(player)[0];
        if (play) {
            changeSpeed();
            vdo.play();
        } else {
            vdo.pause();
        }

        if (play) {
            icon.removeClass('fa-play').addClass('fa-stop');
        } else {
            icon.removeClass('fa-stop').addClass('fa-play');
        }
    });

    // 時間変更時
    $(document).on('input', '#modal-safety_guidance-time-slider', function () {
        let currentTime = $(this).val();

        $('video[id^="modal-safety_guidance-player-"]').each(function() {
            let vdo = $(this)[0];
            vdo.currentTime = currentTime;
        });
    });

    // 音量切り替え
    $(document).on('click', '#modal-safety_guidance-volume_switch', function () {
        let btn = $(this).find('i');

        $('video[id^="modal-safety_guidance-player-"]').each(function() {
            let vdo = $(this)[0];

            if (vdo.muted) {
                vdo.muted = false;
                // Update volume icon based on current volume
                let volume = vdo.volume;
                if (volume == 0) {
                    btn.removeClass().addClass('fa fa-volume-off');
                } else if (volume < 0.5) {
                    btn.removeClass().addClass('fa fa-volume-down');
                } else {
                    btn.removeClass().addClass('fa fa-volume-up');
                }
            } else {
                vdo.muted = true;
                btn.removeClass().addClass('fa fa-volume-mute');
            }
        });

    });

    // 音量変更時
    $(document).on('input', '#modal-safety_guidance-volume-slider', function () {

        let volume = $(this).val();

        $('video[id^="modal-safety_guidance-player-"]').each(function() {
            let vdo = $(this)[0];

            if (vdo.muted) {
                vdo.muted = false;
            }
            vdo.volume = volume;
        });

        // アイコン変更
        let icon = $('#modal-safety_guidance-volume_switch').find('i');

        if (volume == 0) {
            icon.removeClass().addClass('fa fa-volume-off');
        } else if (volume < 0.5) {
            icon.removeClass().addClass('fa fa-volume-down');
        } else {
            icon.removeClass().addClass('fa fa-volume-up');
        }

    });

    // 速度変更ボタンクリック時
    $(document).on('click', '[id^="modal-safety_guidance-speed-"]', function () {
        // 速度取得
        let speed = $(this).attr('id').split('-').pop();
        changeSpeed(speed);
    });

    //モーダルが生成されてから行わせる動作
    $(document).on('shown.bs.modal','#multiple_video-modal', function () {
        select_videos = $('[data-video_arr]').data('video_arr');
        frontVideo = $('#modal-safety_guidance-player-front').get(0);
        rearVideo  = $('#modal-safety_guidance-player-rear').get(0);
        curr_index = 0;
        $('#modal-safety_guidance-player-front').get(0).addEventListener('ended', function () {
            curr_index++;
            if (curr_index >= select_videos.length) {
                return;
            }

            playPair(curr_index);
        });

        // //動画の更新
        $('video[id^="modal-safety_guidance-player-"]').on('timeupdate',function() {
            if (isUserSeeking) {
                 return;
            }
            // 動画の現在時間が更新されたらスライダーを更新
            nowTime = Math.floor(100 * ($(this)[0].currentTime / $(this)[0].duration));
            $('#modal-safety_guidance-time-slider').val(nowTime);
        });
        $('#modal-safety_guidance-time-slider').val(0);

        playPair(curr_index);
    });

    //モーダルが生成されてから行わせる動作
    $(document).on('shown.bs.modal','#guidance-modal', function () {
        //動画の更新
        $('video[id^="modal-safety_guidance-player-"]').on('timeupdate',function() {
            if (isUserSeeking) {
                 return;
            }
            // 動画の現在時間が更新されたらスライダーを更新
            nowTime = Math.floor(100 * ($(this)[0].currentTime / $(this)[0].duration));
            $('#modal-safety_guidance-time-slider').val(nowTime);
        });
        $('#modal-safety_guidance-time-slider').val(0);
    });

    $(document).on('mousedown touchstart', '#modal-safety_guidance-time-slider', function () {
        isUserSeeking = true;
        $('#modal-safety_guidance-play_stop').find('i').removeClass('fa-stop').addClass('fa-play');
        let nc = $('input[name="cameras"]:checked').val();

        let player;
        if($('.multiple_video_box').length) {
            player = $('#modal-safety_guidance-player-front') ;
        } else {
            player = nc == 1 ? $('#modal-safety_guidance-player-front') : $('#modal-safety_guidance-player-rear');
        }

        player[0].pause();
    });

    $(document).on('mouseup touchend', '#modal-safety_guidance-time-slider', function () {
        isUserSeeking = false;
        $('#modal-safety_guidance-play_stop').find('i').removeClass('fa-play').addClass('fa-stop');
        let nc = $('input[name="cameras"]:checked').val();

        let player;
        if($('.multiple_video_box').length) {
            player = $('#modal-safety_guidance-player-front') ;
        } else {
            player = nc == 1 ? $('#modal-safety_guidance-player-front') : $('#modal-safety_guidance-player-rear');
        }

        player[0].play();
    });

     $(document).on('input', '#modal-safety_guidance-time-slider',  function () {
        let nc = $('input[name="cameras"]:checked').val();

        let player;
        if($('.multiple_video_box').length) {
            player = $('#modal-safety_guidance-player-front') ;
        } else {
            player = nc == 1 ? $('#modal-safety_guidance-player-front') : $('#modal-safety_guidance-player-rear');
        }

        let video  = player[0];
        let percent = $(this).val();
        let seekTime = video.duration * (percent / 100);
        video.currentTime = seekTime;
    });

    // 速度変更
    function changeSpeed(speed = null){
        if (speed == null) {
            speed = $('.speed-btn.active').find('[id^="modal-safety_guidance-speed-"]').attr('id').split('-').pop();
        }
        if (speed === "") {
            speed = 0.1; // Default for コマ送り
        } else {
            speed = parseFloat(speed);
        }

        $('video[id^="modal-safety_guidance-player-"]').each(function() {
            let vdo = $(this)[0];

            vdo.playbackRate = speed;
        });
    }

    // 連続再生時に動画のソースを変更する
    function setSources(index) {
        if (!select_videos[index]) return false;

        const movie = select_videos[index];

        //camera_btn_box

        if(movie.camera_type == 'compiled-import') {
            $('#modal-safety_guidance-player-front source').attr('src', movie.uri);
            $('#modal-safety_guidance-player-rear source').attr('src', '');
            $('#video_box').addClass('multiple_video_box');
            $('#video_box')
            .removeClass(function (index, className) {
                return (className.match(/camera_count_\d+/g) || []).join(' ');
            }).addClass('camera_count_' + movie.camera_count);
            $('#modal-safety_guidance-player-front').addClass('camera1');
            if(movie.camera_count >=3) {
                $('#modal-safety_guidance-2c').parent().removeClass('d-none');
                $('#modal-safety_guidance-3c').parent().removeClass('d-none');
            } else if(movie.camera_count >=2) {
                $('#modal-safety_guidance-2c').parent().removeClass('d-none');
                $('#modal-safety_guidance-3c').parent().addClass('d-none');
            } else {
                $('#modal-safety_guidance-2c').parent().addClass('d-none');
                $('#modal-safety_guidance-3c').parent().addClass('d-none');
            }
            $('#modal-safety_guidance-all').parent().removeClass('d-none');
        } else {
            $('#modal-safety_guidance-player-front source').attr('src', movie.front);
            $('#modal-safety_guidance-player-rear source').attr('src', movie.rear);
            $('#video_box').removeClass('multiple_video_box');
            $('#video_box')
            .removeClass(function (index, className) {
                return (className.match(/camera_count_\d+/g) || []).join(' ');
            })
            $('#modal-safety_guidance-player-front').removeClass('camera1');
            $('#modal-safety_guidance-3c').parent().addClass('d-none');
            $('#modal-safety_guidance-all').parent().addClass('d-none');
        }

        $('#modal-safety_guidance-2c').parent().removeClass('active').removeClass('focus');
        $('#modal-safety_guidance-3c').parent().removeClass('active').removeClass('focus');
        $('#modal-safety_guidance-all').parent().removeClass('active').removeClass('focus');
        $('#modal-safety_guidance-1c').parent().addClass('active');

        $('#drive_report_events tbody tr').removeClass('table-primary');
        $('#drive_report_events tbody tr').eq(index).addClass('table-primary');

        frontVideo.load();
        rearVideo.load();

        return true;
    }

    //連続動画のスタート処理
    function playPair(index) {
        if (!setSources(index)) return;

        frontVideo.play();
    }

    // モーダルを閉じる際の処理
    function closeModal()
    {
        $('video[id^="modal-safety_guidance-player-"]').each(function() {
            let vdo = $(this)[0];
            vdo.pause();
        });
        $('.modal-content').empty();
    }

    let isResizing = false;
    let startX = 0;
    let startVideoW = 0;
    let totalW = 0;

    let $videoBox, $mapBox, $border;
    const MIN = 150;

    function getAspectRatio(videoEl){
        if (videoEl.videoWidth && videoEl.videoHeight) {
            return videoEl.videoWidth / videoEl.videoHeight;
        }
        return 16 / 9;
    }

    $(document).on("mousedown", ".variable_border", function (e) {
        $border   = $(this);
        $videoBox = $border.prev(".video_content_box");
        $mapBox   = $border.next(".map_content_box");

        if ($videoBox.length === 0 || $mapBox.length === 0) return;

        isResizing = true;
        startX = e.clientX;

        startVideoW = $videoBox.outerWidth();
        totalW      = $videoBox.outerWidth() + $mapBox.outerWidth();

        e.preventDefault();
    });

    $(document).on("mousemove", function (e) {
        if (!isResizing) return;

        const dx = e.clientX - startX;

        let newVideoW = startVideoW + dx;
        let newMapW   = totalW - newVideoW;

        if (newVideoW < MIN) { newVideoW = MIN; newMapW = totalW - MIN; }
        if (newMapW   < MIN) { newMapW   = MIN; newVideoW = totalW - MIN; }

        const videoEl = $videoBox.find('video')[0];
        if (videoEl) {
            const aspect = getAspectRatio(videoEl);

            const $split = $videoBox.closest('.split-row');
            const splitH = $split.innerHeight();

            const controlsH = $videoBox.find('.video_controls').outerHeight(true) || 0;

            const maxVideoH = Math.max(0, splitH - controlsH - 8);

            const maxVideoW = maxVideoH * aspect;

            if (newVideoW > maxVideoW) {
                newVideoW = maxVideoW;
                newMapW = totalW - newVideoW;
                if (newMapW < MIN) {
                    newMapW = MIN;
                    newVideoW = totalW - MIN;
                }
            }
        }

        $videoBox.css("width", newVideoW + "px");
        $mapBox.css("width", newMapW + "px");
    });

    $(document).on("mouseup", function () {
        isResizing = false;
    });
}
